import { CandyOffOutlineIcon } from './CandyOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 7BA63C38-546A-47FE-8FA7-D3E744B2C96E
 * name candy-off-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/candy-off-outline.svg
 * tags
 * - Food / Drink 
 * - Gaming / RPG 
 */
export const ChocolateOffOutlineIcon = CandyOffOutlineIcon;
export default ChocolateOffOutlineIcon